import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 25 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M10 2C9.17157 2 8.5 2.67157 8.5 3.5V4.5C8.5 5.32843 9.17157 6 10 6H15C15.8284 6 16.5 5.32843 16.5 4.5V3.5C16.5 2.67157 15.8284 2 15 2H10Z" }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M7 4.03662C5.74209 4.10719 4.94798 4.30764 4.37868 4.87694C3.5 5.75562 3.5 7.16983 3.5 9.99826V15.9983C3.5 18.8267 3.5 20.2409 4.37868 21.1196C5.25736 21.9983 6.67157 21.9983 9.5 21.9983H15.5C18.3284 21.9983 19.7426 21.9983 20.6213 21.1196C21.5 20.2409 21.5 18.8267 21.5 15.9983V9.99826C21.5 7.16983 21.5 5.75562 20.6213 4.87694C20.052 4.30764 19.2579 4.10719 18 4.03662V4.5C18 6.15685 16.6569 7.5 15 7.5H10C8.34315 7.5 7 6.15685 7 4.5V4.03662ZM16.0117 12.5483C16.3146 12.2657 16.3309 11.7911 16.0483 11.4883C15.7657 11.1855 15.2911 11.1691 14.9883 11.4517L11.2143 14.9741L10.0117 13.8517C9.70893 13.5691 9.23434 13.5855 8.95171 13.8883C8.66909 14.1911 8.68545 14.6657 8.98826 14.9483L10.7025 16.5483C10.9907 16.8172 11.4379 16.8172 11.726 16.5483L16.0117 12.5483Z"
    }, null, -1)
  ])))
}
export default { render: render }